import React, { useState, useCallback } from 'react';
import { DropdownMenu } from 'reactstrap';
import { ButtonDropdown, DropdownItem } from '../../../components/Dropdowns/ButtonDropdown';
import { SimpleLineIcon } from '../../../components/Icons';

const CollectionTypeButton = props => {
  const [isOpen, setToggle] = useState(false)

  const validateIsActive = useCallback((value) => {
    return props.value?(props.value === value): (value === '')
  }, [props.value])

  return(
    <ButtonDropdown
      isOpen={isOpen}
      toggle={() => setToggle(!isOpen)}
      renderChildren={() => {
        return (
          <DropdownMenu>
            <DropdownItem header>Show Only: </DropdownItem>
            <DropdownItem
              onClick={() => props.onClick('PARENT')}
              active={validateIsActive('PARENT')}
            >
              { validateIsActive('PARENT')? <SimpleLineIcon iconType="check"/>: null } Parents
            </DropdownItem>
            <DropdownItem
              onClick={() => props.onClick('product_variants')}
              active={validateIsActive('product_variants')}
            >
              { validateIsActive('product_variants')? <SimpleLineIcon iconType="check"/>: null } Variants
            </DropdownItem>
            <DropdownItem
              onClick={() => props.onClick('brands')}
              active={validateIsActive('brands')}
            >
              { validateIsActive('brands')? <SimpleLineIcon iconType="check"/>: null } Brands
            </DropdownItem>
            <DropdownItem
              onClick={() => props.onClick('HERO')}
              active={validateIsActive('HERO')}
            >
              { validateIsActive('HERO')? <SimpleLineIcon iconType="check"/>: null } Hero
            </DropdownItem>
            <DropdownItem
              onClick={() => props.onClick('LOOK')}
              active={validateIsActive('LOOK')}
            >
              { validateIsActive('LOOK')? <SimpleLineIcon iconType="check"/>: null } Look
            </DropdownItem>
          </DropdownMenu>
        )
      }}
    />
  )
}
export default CollectionTypeButton;